import { useContext } from 'react';
import {
  ModalProviderContext,
  ModalProviderContextType,
} from './ModalProviderContext';

export const useModalProvider = () =>
  useContext<ModalProviderContextType>(ModalProviderContext);
